import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'
import { useSession } from '../lib/session'
import { Loading } from './ui'

export function RequireViewer({ children }: { children: ReactNode }) {
  const { viewer, loading } = useSession()
  const location = useLocation()
  if (loading) return <Loading label="Burrowing in…" />
  if (!viewer) return <Navigate to={`/signin?next=${encodeURIComponent(location.pathname + location.search)}`} replace />
  return <>{children}</>
}
